<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
>
  <path
    d="M8.00011 0.0322266C3.5115 0.0322266 0.0319824 3.3201 0.0319824 7.7611C0.0319824 10.0842 0.984014 12.0912 2.53429 13.4779C2.66465 13.5942 2.74306 13.7577 2.74848 13.9321L2.79182 15.3497C2.80553 15.8017 3.27278 16.0958 3.68617 15.9132L5.26768 15.2149C5.40186 15.156 5.55198 15.1448 5.69318 15.184C6.42019 15.3838 7.19342 15.4903 7.99979 15.4903C12.4884 15.4903 15.9679 12.2024 15.9679 7.76142C15.9679 3.32042 12.4887 0.0322266 8.00011 0.0322266ZM12.9378 5.69868L10.1636 9.98606C10.0227 10.2037 9.73238 10.2659 9.51469 10.125L6.94481 8.46227C6.84537 8.39789 6.7166 8.39981 6.61907 8.46705L3.7225 10.4648C3.29987 10.7561 2.78322 10.2547 3.0621 9.82383L5.8366 5.53646C5.97748 5.31877 6.26784 5.25662 6.48521 5.3975L9.05573 7.06056C9.15517 7.12494 9.28393 7.12303 9.38146 7.05578L12.2774 5.05838C12.7 4.76676 13.2167 5.26842 12.9378 5.69932V5.69868Z"
    fill="#2596BE"
  />
</svg>